import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "login",
  "data-model-id": "3:5454"
}
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "login-left" }
const _hoisted_4 = { class: "login-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "logo-section" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    alt: "Florisuite Logo",
    src: "https://c.animaapp.com/nNxA75tB/img/frame-402-1.svg"
  })
], -1)
const _hoisted_6 = { class: "form-section" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "form-header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "form-title" }, "Connexion"),
  /*#__PURE__*/_createElementVNode("p", { class: "form-subtitle" }, "Accédez à votre compte Florisuite")
], -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"form-group\"><label class=\"form-label\" for=\"email\">Email</label><input class=\"form-input\" type=\"email\" id=\"email\" placeholder=\"votre.email@exemple.com\" required></div><div class=\"form-group\"><label class=\"form-label\" for=\"password\">Mot de passe</label><input class=\"form-input\" type=\"password\" id=\"password\" placeholder=\"••••••••\" required></div>", 2)
const _hoisted_10 = { class: "form-options" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "checkbox-label" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    class: "checkbox-input"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Se souvenir de moi")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  class: "submit-button",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "button-text" }, "Se connecter")
], -1)
const _hoisted_13 = { class: "signup-prompt" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "prompt-text" }, "Vous n'avez pas de compte ?", -1)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"login-right\"><div class=\"hero-content\"><h2 class=\"hero-title\">Bienvenue sur Florisuite</h2><p class=\"hero-description\"> La plateforme tout-en-un pour gérer votre commerce floral avec simplicité et efficacité. </p><img class=\"hero-image\" alt=\"Florisuite Dashboard\" src=\"https://c.animaapp.com/nNxA75tB/img/image.png\" loading=\"lazy\" decoding=\"async\"></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("form", {
              class: "login-form",
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
            }, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_RouterLink, {
                  to: "/mot-de-passe-oublie",
                  class: "forgot-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mot de passe oublié ? ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_12
            ], 32),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_RouterLink, {
                to: "/inscription",
                class: "signup-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Créer un compte ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _hoisted_15
    ])
  ]))
}